import { Box, Button, Text } from '@medly-components/core';
import styled from 'styled-components';
import MapSmall from '../../../../assets/images/map/Widget-S.png';
import MapMedium from '../../../../assets/images/map/Widget-M.png';
import MapLarge from '../../../../assets/images/map/Widget-L.png';
import { rgba } from 'polished';
import { getFontStyle } from '@medly-components/utils';

export const Header = styled(Text).attrs({ textVariant: 'h1' })`
    margin-bottom: 3.2rem;
    position: relative;
    z-index: 1;
`;

export const MyMapInfoWrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const Background = styled.div`
    background-image: linear-gradient(115deg, #5677a2, ${({ theme }) => theme.colors.darkBlue}, ${({ theme }) => theme.colors.darkBlue});
    height: 35.4rem;
    width: 100%;
    position: absolute;
`;

export const ContentWrapper = styled.div`
    padding: 4rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        padding: 3.2rem;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        padding: 2.4rem;
    }
`;

export const Content = styled(Box)`
    background: ${({ theme }) => theme.colors.white};
    width: 100%;
    overflow-x: hidden;
    align-items: center;
    position: relative;
    box-shadow: 0 0.2rem 0.8rem ${({ theme }) => rgba(theme.colors.grey[500], 0.2)};
    padding: 0;
    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        flex-direction: column;
    }

    ${Button.Style} {
        min-width: 21.6rem;
        max-width: 100%;
    }
`;
export const MapContentBox = styled(Box)`
    background: none;
    display: inline-block;
    width: 46%;
    padding: 0 3.6rem 0 4rem;
    box-sizing: border-box;
    @media (max-width: ${({ theme }) => theme.breakpoints.L.max}px) {
        padding: 0 0 0 3.2rem;
        width: 51%;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        width: 100%;
        padding: 2.4rem;
        margin: 0 auto;
    }
`;

export const Description = styled(Text).attrs({ textVariant: 'body1', textWeight: 'Light' })`
    display: block;
    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        max-width: 55.5rem;
    }
`;

export const IconContainer = styled('div')`
    width: 7.4rem;
    margin-bottom: 1.2rem;

    svg {
        width: 100%;
        height: 100%;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        width: 4.8rem;
    }
`;

export const MapHeader = styled(Text).attrs({ textVariant: 'h1' })`
    color: ${({ theme }) => theme.colors.darkBlue};
    margin-bottom: 1.2rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.L.max}px) {
        padding-right: 4rem;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        padding-right: 0;
        margin-bottom: 0.8rem;
        ${({ theme }) => getFontStyle({ theme, fontVariant: 'h2' })}
    }
`;

export const MapImageBoxWrapper = styled(Box)`
    width: 54%;
    padding: 0;
    align-items: center;
    justify-content: center;
    position: relative;
    @media (max-width: ${({ theme }) => theme.breakpoints.L.max}px) {
        width: 49%;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        width: 100%;
        max-width: 52.8rem;
        box-sizing: border-box;
        margin-left: auto;
        margin-top: ${({ theme }) => theme.spacing.M1};
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        box-sizing: border-box;
    }
`;

export const MapImageBox = styled(Box)`
    width: 100%;
    height: 100%;
    margin-left: auto;
    padding: 0;
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${MapLarge});
    min-height: 53.3rem;
    max-width: 53.8rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        background-image: url(${MapMedium});
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        background-image: url(${MapSmall});
        background-position: top;
    }
    @media (max-width: 425px) {
        min-height: 35.3rem;
    }
`;

export const MapTextWrapper = styled(Text)`
    width: 100%;
    margin-bottom: 4rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        margin-bottom: 3.2rem;
    }
`;
